import { getRandomEnumValue } from '@shared/utils/enum';
import { MyBookingStatus, ProductType } from '../MyBooking/myBooking.interfaces';
import { MyBookingsItem, MyBookings, MyBookingsItemPayment } from './myBookings.interfaces';
import { getDateAddingDuration, getFormattedDate } from '@shared/helpers/datetime/datetime';
import { DateFormat } from '@shared/interfaces/dates';
import { getStoredFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { Market } from '@shared/config/market/market.models';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const stored = getStoredFakeData();
const market: Market = getCurrentMarketSpecs();
const { currency } = market.moneyFormat;

const getPayment = (index: number): MyBookingsItemPayment => {
    const rnd1 = index % 2 === 0;
    const rnd2 = index % 3 === 0;
    const rnd3 = index % 4 === 0;

    const getAmountAlreadyPaid = () => {
        return {
            amountAlreadyPaid: { amount: rnd1 ? 2500 : 0, currency },
        };
    };

    const getFinalPayment = () => {
        return {
            remainingToBePaid: { amount: rnd2 ? 17945 : 0, currency },
            paymentDueTime: rnd2
                ? getFormattedDate(
                      getDateAddingDuration(new Date(), { days: 10 }),
                      DateFormat.ISO
                  )
                : null,
        };
    };

    const getDownPayment = () => {
        return {
            remainingDownPaymentToBePaid: {
                amount: rnd3 ? 1499 : 0,
                currency,
            },
            downPaymentDueTime: rnd3
                ? getFormattedDate(
                      getDateAddingDuration(new Date(), { hours: 2 }),
                      DateFormat.ISO
                  )
                : null,
        };
    };

    return {
        ...getAmountAlreadyPaid(),
        ...getFinalPayment(),
        ...getDownPayment(),
    };
};

const generateItems = (): MyBookingsItem[] => {
    if (!getIsVerified()) {
        return [];
    }

    const getProducts = (count: number) => {
        const products = [
            ProductType.Ferry,
            ProductType.Flight,
            ProductType.Hotel,
            ProductType.Activity,
        ];

        const result = [];
        const productsLength = products.length;

        for (let i = 0; i < count; i++) {
            const randomIndex = Math.floor(Math.random() * productsLength);
            result.push(products[randomIndex]);
        }

        return result;
    };

    const count = stored.bookings.count ?? 3;

    return [...Array(count)].map((_, index): MyBookingsItem => {
        const bookingNumber = '30000' + index;

        const createdDate = getDateAddingDuration(new Date(), {
            days: 3 + index,
        });

        const travelDate = getDateAddingDuration(createdDate, {
            days: 7,
        });

        return {
            bookingNumber,
            bookingId: 400001,
            companyId: 1,
            status: getRandomEnumValue(MyBookingStatus),
            created: getFormattedDate(createdDate, DateFormat.ISO),
            travelDate: getFormattedDate(travelDate, DateFormat.ISO),
            products: getProducts(index + 1),
            payment: getPayment(index),
            link: `/travel/booking?boknid=${bookingNumber}&id=123ABC`,
        };
    });
};

const getIsVerified = (): boolean => {
    return stored?.bookings?.isVerified ?? false;
};

export const fakeData: MyBookings = {
    items: generateItems(),
    verified: getIsVerified(),
};
